export default __webpack_public_path__ + "static/media/image-board-study-ranking-n-m@2x.5454c7c6.png";